import angular from 'angular';
import routinesDetailComponent from './routines-detail.component';
import routinesDetailService from './routines-detail.service';
import routinesDetailConfig from './routines-detail.config';

let routinesDetailModule = angular.module('app.routinesDetail',[])
  .component('routinesDetail', routinesDetailComponent)
  .service('routinesDetailService', routinesDetailService)
  .config(routinesDetailConfig);

export default routinesDetailModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-detail/routines-detail.js
 **/